var API_DOMAIN = "https://viswacrackers.zentexus.in/api";

export default API_DOMAIN;
